var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%"
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 40,
    viewBox: "0 0 375 39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41 375 41 375 11C382 11 332-9 187 23 90 44 27 40 0 11Z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenSeparator);
export default __webpack_public_path__ + "static/media/screen-separator.2724f99afcfff878148591d4416e36fb.svg";
export { ForwardRef as ReactComponent };